<app-card [cardConfig]="workExp"></app-card>
